import { render, staticRenderFns } from "./CreateInstrument.vue?vue&type=template&id=94fd2470"
import script from "./CreateInstrument.vue?vue&type=script&lang=js"
export * from "./CreateInstrument.vue?vue&type=script&lang=js"
import style0 from "./CreateInstrument.vue?vue&type=style&index=0&id=94fd2470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports